import { useFlaggingCallback } from '@databases/flags';
import { defaultStoreUtils } from '@databases/redux';
import { selectHasSelectedCells } from '@databases/redux/cellSelections/selectors';
import { useIntl } from 'react-intl-next';

import { messages } from '../messages';
import { doImportContent } from '../redux/actions';

import { usePasteListener } from './usePaste';

export interface UseImportListenerProps {
  contentId: string;
  currentViewId: string;
  isDisabled?: boolean;
}

/**
 * Listens to document paste events and imports the pasted content into the database (if some cells are selected)
 * or opens the import dialog with the pasted content preselected.
 */
export const useImportListener = ({
  contentId,
  currentViewId,
  isDisabled,
}: UseImportListenerProps) => {
  const scope = 'main';
  const hasSelection = defaultStoreUtils.useEqualSelector((state) =>
    selectHasSelectedCells(state, { contentId })
  );

  const dispatch = defaultStoreUtils.useDispatch();
  const { formatMessage } = useIntl();

  const handlePaste = useFlaggingCallback(
    (files: DataTransferItemList | File[]) => {
      const fieldLabel = formatMessage(
        messages['import-field-settings.field-name-inline-edit-default-text'],
        {
          defaultFieldName: formatMessage(messages['import-field-settings.type-text']),
        }
      );
      dispatch(doImportContent(contentId, files, scope, currentViewId, fieldLabel));
    },
    [contentId, scope, dispatch, formatMessage, currentViewId]
  );

  usePasteListener({ onPaste: handlePaste, isDisabled: !hasSelection || isDisabled });
};
